import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';

import { TableGrid } from '@C/TableGrid';
import { LoanPartyList } from '@C/Utils';
import Select from 'react-select';

const col = [
  {
    name: 'Party name',
    key: '',
  },
  {
    name: 'Mobile',
    key: '',
  },
  {
    name: 'Total outstanding amount',
    key: '',
  },
];

const sortOptions = [
  { value: 'alph', label: 'Alphabetical order' },
  { value: 'out_asc', label: 'Outstanding amount asc' },
  { value: 'out_desc', label: 'Outstanding amount desc' },
];

const LoanList = () => {
  const [state, setState] = useState({
    loanList: [],
    limit: 20,
    party_name: '',
    offset: 1,
    count: 0,
    loading: false,
  });

  const limitInput = useRef();

  useEffect(() => {}, []);

  const submitForm = () => {
    // Add your form submission logic here
  };

  const { loanList, count } = state;

  return (
    <>
      <section className="widget full-width list-table">
        <header>
          <h3>Loan Parties List</h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label> Loan party </label>
                <LoanPartyList
                  value={state.party_name}
                  onChange={(selectedParty) =>
                    setState({
                      ...state,
                      party_name: selectedParty.value || '',
                    })
                  }
                  name="party_name"
                />
              </div>
              <div className="filter-group">
                <label>Sort order</label>
                <Select
                  name="sort_order"
                  options={sortOptions}
                  onChange={(selectedOption) =>
                    setState({ ...state, sortOrder: selectedOption.value })
                  }
                  value={sortOptions.filter(
                    ({ value }) => value === state.sortOrder,
                  )}
                  defaultValue={sortOptions[0]}
                />
              </div>
              <div className="filter-group reset-filter">
                <button
                  onClick={() => {
                    setState({ ...state, party_name: '', sortOrder: '' });
                  }}
                >
                  {' '}
                  Reset filter{' '}
                </button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${state.loading ? 'loading' : ''}`}
                  type="submit"
                  onClick={submitForm}
                  disabled={state.loading}
                >
                  Apply filter
                </button>
              </div>
            </div>
          </div>
          <main className="content-wrapper">
            <TableGrid col={col} row={loanList} count={count} />
          </main>
          <div className="mini-summary">
            <ul>
              <li>
                <span> Total outstanding balance: </span>
                <span>{/* Add the value here */}</span>
              </li>
            </ul>
          </div>
        </main>
      </section>
    </>
  );
};

export default LoanList;
